import * as THREE from './three/three.module.js';
import { GLTFLoader } from './three/jsm/loaders/GLTFLoader.js';
import gsap from "gsap";
import $ from 'jquery';

export default class MLC3D {

	camera;
	scene;
	renderer;
	loup;
	material;
	logo;
	loaded = false;

	constructor() {

		this.renderer = new THREE.WebGLRenderer( { alpha: true });
		this.renderer.setPixelRatio( window.devicePixelRatio );
		this.renderer.setSize( window.innerWidth, window.innerHeight );
		document.getElementById('loup-wrapper').appendChild( this.renderer.domElement );

		window.addEventListener( 'resize', this.resize.bind(this) );

		this.scene = new THREE.Scene();

		this.camera = new THREE.PerspectiveCamera( 45, window.innerWidth / window.innerHeight, 1, 1000 );
		this.camera.position.set( 0, 0, 500 );

		this.scene.add( new THREE.AmbientLight( 0xdedede, .75 ) );

		

		var spotLight = new THREE.SpotLight( 0xeeeeee, .50 );
		spotLight.position.set( 100, 125, 1000 );

		spotLight.castShadow = false;

		spotLight.shadow.mapSize.width = 1024;
		spotLight.shadow.mapSize.height = 1024;

		spotLight.shadow.camera.near = 500;
		spotLight.shadow.camera.far = 4000;
		spotLight.shadow.camera.fov = 30;

		this.scene.add( spotLight );


		this.logo = document.getElementById('animated-loup');


		this.material = new THREE.MeshLambertMaterial( { color: 0xbb0b12} );
		//this.material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, color: 0xf1f1f1 });

		var loader = new GLTFLoader();

		var that = this;

		loader.load( i18n.theme_url + '/img/loup.glb', function ( gltf ) {

			gltf.scene.traverse( function ( child ) {
				if ( child.isMesh ) {
					child.material = that.material;
				}
			} );

			that.loup = gltf.scene;
			that.scene.add( that.loup );

			that.initIntro();

		} );

	}


	animate() {

		requestAnimationFrame( this.animate.bind(this) );

		this.renderer.render( this.scene, this.camera );

	}


	resize () {
		var width = window.innerWidth;
		var height = window.innerHeight;
		this.renderer.setSize (width, height);

		this.camera.aspect = width / height;
		this.camera.updateProjectionMatrix();
	}



	initIntro() {

		this.loaded = true;
		this.loup.position.set(0, 0, 0);
		this.loup.scale.set(2, 2, 2);
		//this.loup.rotation.set(.1, 0, 0);

		this.logo.style.opacity = 1;

		$('body').delay(1.5).removeClass('section-0');

		//this.logo.scale(.5);

		this.animationIntro();

	}

	animationIntro () {



		gsap.to( this.loup.position, {x: 2, y: 0, z: 2, duration: 1.5} );


		var that = this;
			
		gsap.to( this.loup.rotation, {y: -.15, duration: 2, delay: 1.4, ease: "power2.inOut", onComplete: function(){
			var loupRotation = gsap.timeline({repeat: -1});
			loupRotation.fromTo(that.loup.rotation, {y: -.15}, {y: .15, duration: 4, ease: "power2.inOut"});
			loupRotation.to(that.loup.rotation, {y: -.15, duration: 4, ease: "power2.inOut"});
		}} );


		var largeur = window.innerWidth;
		var logoScale = .9;

		if (largeur > 789) {
			logoScale = 2
		}

		var tl_logo = gsap.timeline();
		tl_logo.fromTo( this.logo, {scale: .33, x: 0, y: 0}, {scale: logoScale, x: 0, y: 0, duration: 3, ease: "power2.out", onComplete:this.lunchPage} );
		tl_logo.to( this.logo, {opacity: 0, duration: .5} );



		var tl = gsap.timeline();
		//tl.to( this.loup.scale, {x: 2, y: 2, z: 2, duration: 1.5});
		tl.to( this.loup.scale, {x: .6, y: .6, z: .6, duration: 1.5, ease: "power2.out"} );

		var targetColor = new THREE.Color(0xe1e1e1);

		gsap.to( this.material.color, {
            r: targetColor.r,
            g: targetColor.g,
            b: targetColor.b,
            duration: .5,
            ease: "power2.in"
		});

		//gsap.to( this.loup.position, {x: 2, y: 0, z: 2, duration: 1.5, delay: 1.5, ease: "power2.inOut"} );

	}


	goToSlide ( currentSlide ) {


		switch (currentSlide) {

			case 1:

				var targetColor = new THREE.Color(0xe1e1e1);

				gsap.to( this.material.color, {
	                r: targetColor.r,
	                g: targetColor.g,
	                b: targetColor.b,
	                duration: .5,
	                ease: "power2.in"
				});

				gsap.to( this.loup.position, {x: 2, y: 0, z: 2, duration: 1} );
				gsap.to( this.loup.scale, {x:.6, y:.6, z:.6, duration: 1} );


				var that = this;
			
				gsap.to( this.loup.rotation, {y: -.15, duration: 2, delay: 1.4, ease: "power2.inOut", onComplete: function(){
					var loupRotation = gsap.timeline({repeat: -1});
					loupRotation.fromTo(that.loup.rotation, {y: -.15}, {y: .15, duration: 4, ease: "power2.inOut"});
					loupRotation.to(that.loup.rotation, {y: -.15, duration: 4, ease: "power2.inOut"});
				}} );


				break;

			case 2:
				gsap.killTweensOf(this.loup.rotation);
				gsap.to( this.loup.scale, {x: 2, y: 2, z: 2, duration: 1} );
				gsap.to( this.loup.position, {x: -100, y: -125, duration: 1} );
				gsap.to( this.loup.rotation, {y: 0, duration: 1} );

				var targetColor = new THREE.Color(0xbb0b12);

				gsap.to( this.material.color, {
	                r: targetColor.r,
	                g: targetColor.g,
	                b: targetColor.b,
	                duration: .5,
	                ease: "power2.in"
				});

				break;


			case 3:
				gsap.killTweensOf(this.loup.rotation);
				gsap.to( this.loup.scale, {x: 2.5, y: 2.5, z: 2.5, duration: 1} );
				gsap.to( this.loup.position, {x: -200, y: 200, duration: 1} );
				gsap.to( this.loup.rotation, {y: 0, duration: 1} );

				var targetColor = new THREE.Color(0xe1e1e1);

				gsap.to( this.material.color, {
	                r: targetColor.r,
	                g: targetColor.g,
	                b: targetColor.b,
	                duration: .5,
	                ease: "power2.in"
				});

				break;


			case 4:
				gsap.killTweensOf(this.loup.rotation);
				gsap.to( this.loup.scale, {x: 2, y: 2, z: 2, duration: 1} );
				gsap.to( this.loup.position, {x: 200, y: 100, duration: 1} );
				gsap.to( this.loup.rotation, {y: .25, duration: 1} );

				var targetColor = new THREE.Color(0xe1e1e1);

				gsap.to( this.material.color, {
	                r: targetColor.r,
	                g: targetColor.g,
	                b: targetColor.b,
	                duration: .5,
	                ease: "power2.in"
				});

				break;

		}

	}

	lunchPage() {

  		document.body.classList.add("loaded");
  		let event = new Event("Lunch");
  		document.dispatchEvent(event);
  		
	} 

}


//var mlc3d = new MLC3D();
//mlc3d.animate();

